export const AVAILABILITY_ERROR_TITLE =
  "Uh oh! We were unable to process your search request.";
export const AVAILABILITY_ERROR_SUBTITLE = "Something went wrong.";
